import axios from 'axios'

export const authPost = (url, data) => axios.post(url, data)

export const authDelete = (url, config) => axios.delete(url, config)
